<template>
  <div>
    <div>
      <custom-drop-down
        v-model="model.academicYear"
        class="custom-drop-down__extended"
        :clearable="false"
        fieldkey="year"
        fieldname="description"
        label="Año Académico:"
        :options="catalog.academicYears"
        @input="onChangeAcademicYearHandler"
      />
      <hr />
    </div>
    <div>
      <custom-callout
        v-if="!hasVendorInfo && model.academicYear"
        border-color="primary-1"
        class-main="py-3"
        :has-border="false"
        :has-toggle="false"
      >
        <div class="row d-flex justify-content-center">
          <action-button
            class="border w-40 btn"
            i="fas fa-list color-primary-1"
            :text="searchButtonText"
            @click="onSyncAndGetVendorInfo"
          />
        </div>
      </custom-callout>
    </div>
    <div v-if="hasVendorInfo">
      <general-info
        class="mt-4"
        :value="data.vendorInfo || {}"
        @on-update-vendor="onSyncAndGetVendorInfo"
      />
      <contract-info
        class="mt-5"
        :value="data.contractInfo || {}"
        @on-update-po="onUpdatePoHandler"
      />
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import { GeneralInfo, ContractInfo } from './components';
import {
  getVendorInfo as _getVendorInfo,
  getAcademicYears as _getAcademicYears,
  updatePurchaseOrderDetails as _updatePurchaseOrderDetails,
} from '@/modules/sifdeVendor/api.js';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'Main',
  components: {
    CustomDropDown,
    CustomCallout,
    ActionButton,
    GeneralInfo,
    ContractInfo,
  },
  mixins: [alertMixin],
  props: {
    companyId: {
      type: [Number, String],
      default: () => null,
    },
  },
  data: () => ({
    catalog: {
      academicYears: [],
    },
    model: {
      academicYear: null,
    },
    data: null,
    showInfo: false,
  }),
  computed: {
    formattedSSN() {
      return this.ssn.replace('-', '');
    },
    hasVendorInfo() {
      return this.data?.vendorInfo;
    },
    searchButtonText() {
      return `Presione para consultar datos del ${this.model?.academicYear
        ?.year || ''}`;
    },
  },
  async mounted() {
    await this.getAcademicYears();
  },
  methods: {
    async getVendorInfo(budgetReference, sync = null) {
      this.data = (
        await _getVendorInfo(this.companyId, budgetReference, sync)
      ).data;
    },
    async getAcademicYears() {
      const academicYears = (await _getAcademicYears()).data;
      this.catalog.academicYears = academicYears;
      this.model.academicYear = academicYears[0];

      this.getVendorInfo(academicYears[0].year);
    },
    onSyncAndGetVendorInfo() {
      const budgetRef = this.model.academicYear?.year;
      this.getVendorInfo(budgetRef, true);
    },
    onChangeAcademicYearHandler(value) {
      if (value?.id) {
        this.getVendorInfo(value.year);
      }
    },
    async onUpdatePoHandler(purchaseOrderId) {
      if (purchaseOrderId) {
        const budgetRef = this.model.academicYear?.year;
        await _updatePurchaseOrderDetails(purchaseOrderId, budgetRef);
        await this.getVendorInfo(budgetRef);
        this.ShowToast(
          '',
          'El PO ha sido actualizado exitosamente.',
          'success'
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-drop-down__extended ::v-deep {
  max-width: 200px !important;
}
</style>
